import React from "react"
import { type ChakraProps, Flex, Box, Heading, Button } from "@chakra-ui/react"

interface ErrorMessageProps {
  error: string | undefined | null
  styles?: ChakraProps
  buttonStyles?: ChakraProps
  primaryAction: boolean
  primaryActionText: string
  primaryActionCallBack?: () => void
  secondaryMessage?: string
}

export const ErrorMessage = ({
  error,
  styles,
  primaryAction,
  primaryActionText,
  primaryActionCallBack,
  secondaryMessage,
  buttonStyles
}: ErrorMessageProps): JSX.Element => {
  const handlePrimaryAction = (): void => {
    primaryActionCallBack?.()
  }

  return (
    <>
      {error && (
        <Flex h="70vh" display={"grid"} gridTemplateColumns={"1fr"} align={"center"} flexDir={"column"} p="4" {...styles}>
          <Box>
            <Heading variant="Heading1SemiBold" maxW="860px">
              {error ?? "Something went wrong"}
            </Heading>
            {secondaryMessage && (
              <Heading variant="Heading3PT" mt={["14px", "14px", "0"]}>
                {secondaryMessage}
              </Heading>
            )}

            {primaryAction && (
              <Button mt="7" variant="full-rounded" onClick={handlePrimaryAction} {...buttonStyles}>
                {primaryActionText ?? "Ok"}
              </Button>
            )}
          </Box>
        </Flex>
      )}
    </>
  )
}
